import { getIsLoggedIn, getIsMobile } from '../../publicSession/selectors';
export var getDuperRedirectThreshold = function (state) {
    return getIsMobile(state) ? 2 : 3;
};
export var isBannerVisible = function (state) {
    return !getIsLoggedIn(state);
};
//# sourceMappingURL=selectors.js.map